import { FunctionComponent } from 'react';
import { ErrorMessage, Field, FieldProps } from 'formik';

import { Text } from '@/atoms';

import { EmptyStar, Star } from '@/icons';

import { TypeValuationStampsProps } from './types';

/**
 * ValuationStamps
 */
export const ValuationStamps: FunctionComponent<TypeValuationStampsProps> = ({
  className = '',
  text,
  name,
}: TypeValuationStampsProps) => (
  <Field name={name}>
    {({ field, form: { setFieldValue } }: FieldProps) => (
      <div className={className}>
        <input type="range" min="1" max="5" hidden {...field} />
        <Text className="text-subtitle text-subtitle--s text-text-tertiary">
          {text}
        </Text>

        <div className="flex items-center gap-6 mt-4">
          {[1, 2, 3, 4, 5].map((rating) => (
            <button
              key={rating}
              type="button"
              onClick={() => setFieldValue(field.name, rating)}
            >
              {field.value >= rating ? (
                <Star width={32} height={32} color="#C78938" />
              ) : (
                <EmptyStar width={32} height={32} color="#C78938" />
              )}
            </button>
          ))}
        </div>

        <ErrorMessage name={name}>
          {(msg) => (
            <div className="text-body text-body--s text-status-error">
              {msg}
            </div>
          )}
        </ErrorMessage>
      </div>
    )}
  </Field>
);

ValuationStamps.displayName = 'ValuationStamps';
